







































































































































import Vue from 'vue';
import _ from 'lodash';

import CustomDialog from '../CustomDialog.vue';
import Confirmar from '../Confirmar.vue';
import { Paciente } from '../../../../back/src/entity/Paciente';
import Requester from '../../requester/index';
import { Documento } from '../../../../back/src/entity/Documento';
import { awsS3URL } from '../../utils/constants';
import { DocumentoAlterarFormData } from '../../../../back/src/types';

export default Vue.extend({
  name: 'ThePacientesDadosDocumentos',
  components: {
    CustomDialog,
    Confirmar,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
  },
  data() {
    return {
      loading: false,
      showDocumentos: true,
      dialogDocumento: false,
      documentoSelecionado: null,
      documentos: [],
      file: null,
      form: {
        detalhes: null,
      },
      filesizeLimit: 15000000,
      headers: [
        {
          value: 'nome_original',
          text: 'Nome ',
          class: 'text-no-wrap',
          sortable: true,
        },
        {
          value: 'created',
          text: 'Enviado em ',
          class: 'text-no-wrap',
          sortable: true,
          width: 160,
        },
        {
          value: 'tamanho',
          text: 'Tamanho ',
          class: 'text-no-wrap',
          sortable: false,
          width: 160,
        },
        {
          value: 'detalhes',
          text: 'Detalhes ',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'abrir',
          text: 'Abrir ',
          class: 'text-no-wrap',
          sortable: false,
          width: '0',
          align: 'center',
        },
        {
          value: 'alterar',
          text: 'Alterar ',
          class: 'text-no-wrap',
          sortable: false,
        },
        {
          value: 'excluir',
          text: 'Excluir ',
          class: 'text-no-wrap',
          sortable: false,
          width: '0',
          align: 'center',
        },
      ],
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    formDocumento():
      Vue & { validate: () => boolean, reset: () => void, resetValidation: () => void } {
      return this.$refs.formDocumento as Vue & {
        validate: () => boolean,
        reset: () => void,
        resetValidation: () => void
      };
    },
    rulesDocumento(): any[] {
      if (this.file) {
        return _.concat(this.rules.required, this.maxSize);
      }
      return this.rules.required;
    },
    dialogTitle() {
      if (this.documentoSelecionado) return 'Alterar documento';
      return 'Novo documento';
    },
  },
  mounted() {
    this.buscaDocumentos();
  },
  methods: {
    async excluiDocumento(documento: Documento) {
      if (await this.confirmar.open(
        'Excluir documento',
        'Tem certeza que deseja excluir este documento?',
      ) === false) {
        return;
      }
      this.loading = true;
      try {
        const response = await Requester.paciente.excluirDocumento(
          this.paciente.id,
          (documento.id as number),
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          const index: number = _.findIndex(
            this.documentos,
            (el: Documento) => el.id === documento.id,
          );
          if (index >= 0) {
            this.documentos.splice(index, 1);
          }
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Documento excluido com sucesso' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    async abrirDialogAlterarDocumento(documento: Documento) {
      this.documentoSelecionado = documento;
      this.form.detalhes = documento.detalhes;
      this.dialogDocumento = true;
    },
    fileIcon(item: Documento): string {
      const pedacos: string[] = item.mimetype.split('/');
      const type: string = pedacos[0];
      const subtype: string = pedacos[1] || '';
      if (type === 'image') return 'file-image';
      if (type === 'audio') return 'file-audio';
      if (type === 'video') return 'file-video';
      if (type === 'text') return 'file-alt';
      if (type === 'application') {
        switch (subtype) {
          case 'pdf':
            return 'file-pdf';
          case 'msword':
            return 'file-word';
          case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
            return 'file-word';
          case 'vnd.ms-powerpoint':
            return 'file-powerpoint';
          case 'vnd.openxmlformats-officedocument.presentationml.presentation':
            return 'file-powerpoint';
          case 'vnd.ms-excel':
            return 'file-excel';
          case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return 'file-excel';
          default:
            break;
        }
      }
      return 'file';
    },
    formatSize(tamanho: number): string {
      if (tamanho >= 1000000) return `${(tamanho / 1000000).toFixed(2)} MB`;
      if (tamanho >= 1000) return `${(tamanho / 1000).toFixed(2)} KB`;
      return `${(tamanho).toFixed(2)} bytes`;
    },
    abreDocumento(documento: Documento) {
      window.open(`${awsS3URL}${documento.documento_aws_key}`, '_blank');
    },
    maxSize(file: any) {
      if (file.size > this.filesizeLimit) {
        return `O arquivo é muito grande. (limite: ${this.filesizeLimit / 1000000} MB)`;
      }
      return true;
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () {
      if (this.documentoSelecionado) {
        await this.submitAlterarDocumento();
      } else {
        await this.submitCriarDocumento();
      }
    }, 200),
    async submitCriarDocumento() {
      this.loading = true;
      if (!this.formDocumento.validate()) {
        this.loading = false;
        return;
      }
      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('paciente_id', this.paciente.id);
      formData.append('nome_original', this.file.name);
      formData.append('mimetype', this.file.type);
      formData.append('tamanho', this.file.size);
      formData.append('detalhes', this.form.detalhes);
      try {
        const response = await Requester.paciente.criaDocumento(this.paciente.id, formData);
        this.documentos.push(response.data);
        this.formDocumento.reset();
        this.dialogDocumento = false;
        this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Documento criado com sucesso' });
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    async submitAlterarDocumento() {
      this.loading = true;
      if (!this.formDocumento.validate()) {
        this.loading = false;
        return;
      }
      const formData: DocumentoAlterarFormData = {
        id: this.documentoSelecionado.id,
        detalhes: this.form.detalhes,
      };
      try {
        const response = await Requester.paciente.alteraDocumento(
          this.paciente.id,
          this.documentoSelecionado.id,
          formData,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          const index: number = _.findIndex(
            this.documentos,
            (el: Documento) => el.id === response.data.id,
          );
          if (index >= 0) {
            this.documentos.splice(index, 1, response.data);
          }
          this.formDocumento.reset();
          this.dialogDocumento = false;
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Documento alterado com sucesso' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    async buscaDocumentos() {
      this.loading = true;
      try {
        const response = await Requester.paciente.documentos(this.paciente.id);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.documentos = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    dialogDocumento() {
      if (!this.dialogDocumento) {
        this.form.detalhes = null;
        this.documentoSelecionado = null;
      }
    },
  },
});
